import React, { Component } from "react";
import { Container } from "./styles.js";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as ModaisMinimizadosActions } from "../../store/ducks/modaisMinimizados";
import { Creators as StorePropostasPageActions } from "../../store/ducks/PageStores/propostasStores";
import { Creators as StoreClientesPageActions } from "../../store/ducks/PageStores/clientesStores";
import MaximizeButton from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
const tenant = localStorage.getItem("@ecorban-app:tenant");

class Footer extends Component {
  handleMaximize = (title, funcMax) => {
    let pivot = this.props.modaisMinimizados.filter(
      (modal) => modal.title !== title
    );
    this.props.removeModal(pivot);
    if (title === "Editar proposta") {
      this.props.setAction("EDIT");
    }
    if (title === "Cadastrar proposta") {
      this.props.setAction("NEW");
    }
    if (title === "Detalhes da proposta") {
      this.props.setAction("DETAIL");
    }
    if (title === "Editar cliente") {
      this.props.setClienteAction("EDIT");
    }
    if (title === "Cadastrar cliente") {
      this.props.setClienteAction("NEW");
    }
    if (title === "Detalhes do cliente") {
      this.props.setClienteAction("DETAIL");
    }
    funcMax();
  };

  render() {
    return (
      <Container id="footer">
        <span
          style={{
            color: "#2a9500",
            width: "100%",
            fontSize: "15px",
            textAlign: "center",
            marginTop: "10px",
            fontWeight: "bold",
          }}
        >
          Acesse agora a nova versão do eCorban! Novas funcionalidades e mais
          produtividade no seu dia a dia. <br></br>
          <span
            style={{
              color: "#333333",
              width: "100%",
              fontSize: "15px",
              textAlign: "center",
            }}
          >
            Clique{" "}
            <a href={`https://ecorban.com/${tenant}`} target="_blank">
              aqui
            </a>{" "}
            ou digite em seu navegador:{" "}
            <a href={`https://ecorban.com/${tenant}`} target="_blank">
              {`https://ecorban.com/${tenant}`}
            </a>
          </span>
        </span>

        <div className="modais-minimizados">
          {this.props.modaisMinimizados.map((modal) => (
            <div key={`mm-${modal.title}`} className="modal-minimizado">
              {modal.title}
              <IconButton
                onClick={() => this.handleMaximize(modal.title, modal.funcMax)}
                className="mr1 text-button"
              >
                <MaximizeButton />
              </IconButton>
            </div>
          ))}
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  modaisMinimizados: state.modaisMinimizados.data,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...ModaisMinimizadosActions,
      ...StorePropostasPageActions,
      ...StoreClientesPageActions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/index.js